import React, {createContext, useContext} from "react";
import {useAuthState} from 'react-firebase-hooks/auth';
import {getFirebase} from "../config/firebase.config";

const {auth} = getFirebase();
const AuthContext = createContext({});

// export a provider
export const AuthProvider = ({children}) => {
    const [user, loading, error] = useAuthState(auth);
    if (user) {
        user.getIdTokenResult().then(idTokenResult => {
            user.admin = idTokenResult.claims.admin;
        })
    }
    return <AuthContext.Provider value={{user, error, loading}}>
        {!loading && children}
    </AuthContext.Provider>
}

// export a hook
export const useAuth = () => useContext(AuthContext);